import { Scale } from "../../../utils/Scale"

export class PhysPos {

    static titleY = () => Scale.height() * 0.03

    static scientistX = () => Scale.width() * 0.21
    static scientistY = () => Scale.height() * 0.12

    static scientistX2 = () => Scale.width() * 0.53
    static scientistY2 = () => Scale.height() * -0.105

    static deskX = () => 0
    static deskY = () => Scale.height() * 0.31

    static deskX2 = () => 0
    static deskY2 = () => Scale.height() * 0.53

    static physicalBrainX = () => Scale.width() * 0.45
    static physicalBrainY = () => Scale.height() * 0.02

    static paTitleY = () => Scale.height() * 0.06

    static cigaretteX = () => PhysPos.physicalBrainX() + (Scale.width() * 0.102)
    static cigaretteY = () => PhysPos.physicalBrainY() + (Scale.height() * 0.214)

    static frogX = () => Scale.width() * 0.51
    static frogY = () => Scale.height() * 0.38

    static frogVertexX1 = () => Scale.width() * 0.449
    static frogVertexY1 = () => Scale.height() * 0.3

    static frogVertexX2 = () => Scale.width() * 0.285
    static frogVertexY2 = () => Scale.height() * 0.33

    static frogVertexX3 = () => Scale.width() * 0.145
    static frogVertexY3 = () => Scale.height() * 0.33

    static frogDeskX = () => Scale.width() * 0.215

    static beaker1PlatformX = () => Scale.width() * 0.09
    static beaker2PlatformX = () => Scale.width() * 0.34

    static bunsenLeftX = () => Scale.width() * -0.025
    static bunsenLeftY = () => Scale.height() * 0.6

    static bunsenRightX = () => Scale.width() * 0.3
    static bunsenRightY = () => Scale.height() * 0.56

    static beakerLeftX = () => Scale.width() * 0.08
    static beakerRightX = () => Scale.width() * 0.325
    static beakerY = () => Scale.height() * 0.5

    static bubblesLeftX = () => Scale.width() * 0.1
    static bubblesRightX = () => Scale.width() * 0.342
    static bubblesY = () => Scale.height() * 0.573

    static flameLeftX = () => Scale.width() * 0.13
    static flameLeftY = () => Scale.height() * 0.635

    static flameRightX = () => Scale.width() * 0.374
    static flameRightY = () => Scale.height() * 0.63

}
